import DeEscapeTxt from "./DeEscapeTxt";


function TextOrMdash(props: any) {
    console.log("props");
    console.log(props.text.length);
    console.log(props.text);
    console.log(DeEscapeTxt(props.text));
    return (
        <div>{(typeof (props.text) !== 'undefined' && props.text !== null && props.text.length!==0)
                ? <div className="itemRowParagraphWrap">{DeEscapeTxt(props.text)}</div>
                : <div className="">&mdash;</div>}
        </div>
    )
}
export default TextOrMdash